import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=2663b584&scoped=true&"
import script from "./AssetDetails.vue?vue&type=script&lang=js&"
export * from "./AssetDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetails.vue?vue&type=style&index=0&id=2663b584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663b584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2663b584')) {
      api.createRecord('2663b584', component.options)
    } else {
      api.reload('2663b584', component.options)
    }
    module.hot.accept("./AssetDetails.vue?vue&type=template&id=2663b584&scoped=true&", function () {
      api.rerender('2663b584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssetTracking/AssetDetails.vue"
export default component.exports